import { component as defineComponent } from 'flightjs';

function ChatStatus() {
    this.attributes({
        'chatAvailableSelector': '[data-chat-available]',
        'chatUnavailableSelector': '[data-chat-unavailable]'
    });

    this.after('initialize', function() {
        this.on(document, 'chatSupportOnline', this.showAvailable);
        this.on(document, 'chatSupportOffline', this.showUnavailable);
    });

    this.showAvailable = function() {
        this.select('chatUnavailableSelector').attr('data-hidden', true);
        this.select('chatAvailableSelector').removeAttr('data-hidden');
    };

    this.showUnavailable = function() {
        this.hideAvailable();
        this.select('chatUnavailableSelector').removeAttr('data-hidden');
    };

    this.hideAvailable = function() {
        this.select('chatAvailableSelector').attr('data-hidden', true);
    };
};

export default defineComponent(ChatStatus);



// WEBPACK FOOTER //
// ./~/@99designs/brand-container/lib/ui/chat-status.js